import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";
import {v4 as uuidv4} from 'uuid';

import { FONT } from "../../../value/staticValues";
import { ERROR_CODE } from "../../../value/type";
import { PLATFORM_URL } from "../../../value/Url";
import { base64Encoding, getCurrentTimestamp, getTimestampToDate } from "../../../common/util";
import { requests } from "../../../common/RestAPI";
import { ValidationError } from "../../../common/ExceptionError";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import { AttachedSecurityGroup } from "./VmDetailContainer";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomText from "components/base/CustomText";

interface VolumeDetail {
    volumeId: string;
    volumeName: string;
    volumeDesc: string;
    volumeSizeGb: string;
    baseImageName: string;
    
}

interface ArgsType {
    vmId: string;
    projectId: string;
}

interface VmVolumeAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

VmVolumeAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function VmVolumeAdd(props:VmVolumeAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    
    const [volumeId, setVolumeId] = useState("");
    const [device, setDevice] = useState("");
    const [volumeList, setVolumeList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [volumeDetailList, setVolumeDetailList] = useState<VolumeDetail[]>([]);
    const [deviceWarnYn, setDeviceWarnYn] = useState(false);
    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkVolumeData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
            
        }
    }, [props.clickedConfirmYn]);


    useEffect(() => {
        if(stepIndex === 0) {
            loadVolumeList();
        }
    }, [stepIndex])

    useEffect(() => {
        if(executeAddYn) {
            executeAdd();
        }
    }, [executeAddYn]);


    function loadVolumeList() {
        requests.get(PLATFORM_URL.PROJECT + '/' + props.args?.projectId + PLATFORM_URL.VOLUME, {size: 9999})
        .then((response) => {
            setVolumeList(response.data.items.map((data, index) => {
                if(data.volume_status_code === "AVB") {
                    return {
                        value: data.volume_id,
                        label: data.volume_name,
                    }
                } else {
                    return false;
                }
            }).filter((v)=>{if(v !== false) return v}));
            setVolumeDetailList(response.data.items.map((data, index) => {
                if(data.volume_status_code === "AVB") {
                    return {
                        volumeId: data.volume_id,
                        volumeName: data.volume_name,
                        volumeDesc: data.volume_description,
                        volumeSizeGb: data.volume_size_gb.toString(),
                        baseImageName: data.base_vm_image_name ? data.base_vm_image_name : ""
                    }
                } else {
                    return false;
                }
            }).filter((v)=>{if(v !== false) return v}));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }


    function checkVolumeData() {
        
        let message = "";
        let error = false;
        setDeviceWarnYn(false);
        if(!volumeId) {
            message = t("MESSAGE_VM_VOLUME_ENTER_ERROR_MESSAGE");
            error = true;
        }
        if(error == true)
            if(props.showMessageCb){
                props.showMessageCb(message);
        }
        return !error;
    }


    function executeAdd() {
        const addPackageData = {
            volume: {
                volume_id: volumeId
            },
            vm: {
                vm_id: props.args?.vmId
            }
        };
        if(device) {
            addPackageData['volume']['attach_device'] = device;
        }

        requests.post(PLATFORM_URL.VOLUME + '/' + volumeId + "/attach/vm", addPackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }

    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("MESSAGE_VM_VOLUME_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VM_VOLUME_SELECT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown 
                                key={10} 
                                width={300} height={36} 
                                items={volumeList}
                                setValue={setVolumeId} 
                                disable={false}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                        {
                            (()=>{
                                for(let volumeDetail of volumeDetailList) {
                                    if(volumeDetail.volumeId === volumeId) {
                                        return (
                                            <View style={{
                                                width: 570, minHeight: 90,
                                                marginLeft: 150,
                                                marginBottom: 40,
                                                borderRadius: 10,
                                                backgroundColor: "#f5f7fa",
                                                paddingTop: 20, paddingBottom: 10, paddingLeft: 20, paddingRight: 10
                                                }}>
                                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                    <Text style={{
                                                        width: 130,
                                                        height: 20,
                                                        fontFamily: FONT.MEDIUM,
                                                        fontSize: 12,
                                                        color: "#333"
                                                    }}> {t("VM_VOLUME_SIZE_TEXT")}
                                                    </Text>
                                                    <Text style={{
                                                        height: 20,
                                                        fontFamily: FONT.MEDIUM,
                                                        fontSize: 12,
                                                        color: "#3a8344"
                                                    }}> {volumeDetail.volumeSizeGb} GB
                                                    </Text>
                                                </View>
                                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                    <Text style={{
                                                        width: 130,
                                                        height: 20,
                                                        fontFamily: FONT.MEDIUM,
                                                        fontSize: 12,
                                                        color: "#333"
                                                    }}> {t("VM_BASE_IMAGE_TEXT")}
                                                    </Text>
                                                    <Text style={{
                                                        height: 20,
                                                        fontFamily: FONT.MEDIUM,
                                                        fontSize: 12,
                                                        color: "#333"
                                                    }}> {volumeDetail.baseImageName}
                                                    </Text>
                                                </View>
                                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 10}}>
                                                    <Text style={{
                                                        width: 130,
                                                        height: 20,
                                                        fontFamily: FONT.MEDIUM,
                                                        fontSize: 12,
                                                        color: "#333"
                                                    }}> {t("VM_VOLUME_DESCRIPTION_TEXT")}
                                                    </Text>
                                                    <Text style={{
                                                        height: 20,
                                                        fontFamily: FONT.MEDIUM,
                                                        fontSize: 12,
                                                        color: "#333"
                                                    }}> {volumeDetail.volumeDesc}
                                                    </Text>
                                                </View>
                                            </View>
                                        )
                                    }
                                }
                            })()
                        }
                        <View style={style.rowContainer}>
                            <CustomText text={t("CONNECT_DEVICE_NAME_TEXT")} fontStyle={style.columnText} asterisk={false}/>
                            <CustomTextInput 
                                key={5} 
                                width={570} height={36} 
                                value={device} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setDevice} 
                                warnYn={deviceWarnYn} 
                                placeHolderText={t("/dev/vdb")}
                            />
                        </View>
                        <Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                            {t("DESCRIBE_VM_VOLUME_ATTACH_TEXT")}
                        </Text>
                    </View>
                </View> 
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    statusImg: {
        marginRight: 3
    },
    dataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    }
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}